import { Button, UIHeading1, Body1 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './NewbuildingBrokerConsultantBanner.css';

export type TNewbuildingBrokerConsultantBannerVariant = 'A' | 'B' | 'C';

interface IVariantContent {
  title: React.ReactNode;
  description: React.ReactNode;
  modifierClass?: string;
}

// TODO: Удалить неактуальные варианты по итогам CD-292104.
const VARIANT_CONTENT: Record<TNewbuildingBrokerConsultantBannerVariant, IVariantContent> = {
  A: {
    title: (
      <>
        Подберём и{NBSP}поможем купить квартиру в{NBSP}новостройке. Бесплатно!
      </>
    ),
    description: (
      <>
        Найдём тот{NBSP}самый вариант под{NBSP}ваш{NBSP}бюджет
      </>
    ),
  },
  B: {
    title: (
      <>
        Квартира под{NBSP}ваш{NBSP}бюджет
      </>
    ),
    description: <>Найдём лучшую и{NBSP}поможем сэкономить</>,
    modifierClass: styles['container-economy'],
  },
  C: {
    title: <>Найдём надёжного застройщика</>,
    description: <>Подберём квартиру, проверим документы</>,
    modifierClass: styles['container-safety'],
  },
};

interface INewbuildingBrokerConsultantBannerProps {
  buttonText?: string;
  buttonLoading: boolean;
  variant?: TNewbuildingBrokerConsultantBannerVariant;
  onClick: () => void;
}

export const NewbuildingBrokerConsultantBanner: React.FC<INewbuildingBrokerConsultantBannerProps> = ({
  buttonText = 'К заявке',
  buttonLoading,
  variant = 'A',
  onClick,
}) => {
  const { title, description, modifierClass } = VARIANT_CONTENT[variant];

  return (
    <section className={clsx(styles['container'], modifierClass)} data-testid="BrokerBanner" data-name="BrokerBanner">
      <div className={styles['inner']}>
        <UIHeading1>{title}</UIHeading1>
        <div className={styles['description-wrapper']}>
          <Body1>{description}</Body1>
        </div>
        <div>
          <Button theme="fill_primary" loading={buttonLoading} onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};
